// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1-jDnHtCMrbeWDm4CxribY {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n}", ""]);
// Exports
exports.locals = {
	"container": "_1-jDnHtCMrbeWDm4CxribY"
};
module.exports = exports;
